/*
 * use-local-storage
 */
import { Dispatch, useEffect, useState } from "react"

export function useLocalStorage<T>(
	key: string,
	initialValue?: T,
): [T, Dispatch<T>] {
	const [value, setValue] = useState(() => {
		try {
			const storedValue = localStorage.getItem(key)
			return storedValue ? JSON.parse(storedValue) : initialValue
		} catch {
			return initialValue
		}
	})

	useEffect(() => {
		const handleStorageChange = (event: any) => {
			if (event.key === key && event.newValue !== event.oldValue) {
				setValue(JSON.parse(event.newValue))
			}
		}

		window.addEventListener("storage", handleStorageChange)

		return () => {
			window.removeEventListener("storage", handleStorageChange)
		}
	}, [key])

	const saveValue = (newValue: T) => {
		try {
			localStorage.setItem(key, JSON.stringify(newValue))
			setValue(newValue)
		} catch (error) {
			console.error(`Error setting key "${key}" to localStorage:`, error)
		}
	}

	return [value, saveValue]
}
